import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'

function Brands() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="2119" className="elementor elementor-2119">
										<div className="elementor-element elementor-element-3b4258d e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="3b4258d" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-3c734db e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="3c734db" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-54caf4a elementor-invisible elementor-widget elementor-widget-elementskit-heading" data-id="54caf4a" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Brands</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div></div></div>				</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-7e45641 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="7e45641" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-4d51bca e-grid e-con-full wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="4d51bca" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-913f0c3 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="913f0c3" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
														<div className="elementor-element elementor-element-ea365e6 elementor-widget elementor-widget-ucaddon_icon_image_content_box" data-id="ea365e6" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_icon_image_content_box.default">
															<div className="elementor-widget-container">
<div className="uc_icon_image_content_box" id="uc_icon_image_content_box_elementor_ea365e6">
																	<div className="uc_content_box_area">



																		<div className="uc_thumb">
																			<a>
																				<img decoding="async" src="/assets/images/03/CNC05371-scaled.jpg" alt="CNC05371" />
																			</a>
																		</div>
																		<div className="uc_details">
																			<a className="uc_details-icon">
																				<i className="fas fa-gift"></i>							</a>
																			<div className="uc_text">TSR CATERING &amp; EVENTS</div>			<a className="uc_btn">Show More</a>		</div>
																	</div>
																</div>
																{/* end Icon Image Content Box */}				</div>
														</div>
													</div>
													<div className="elementor-element elementor-element-399f8e8 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="399f8e8" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
														<div className="elementor-element elementor-element-072965a elementor-widget elementor-widget-ucaddon_icon_image_content_box" data-id="072965a" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_icon_image_content_box.default">
															<div className="elementor-widget-container">
<div className="uc_icon_image_content_box" id="uc_icon_image_content_box_elementor_072965a">
																	<div className="uc_content_box_area">



																		<div className="uc_thumb">
																			<a>
																				<img decoding="async" src="/assets/images/01/meal.jpg" alt="meal" />
																			</a>
																		</div>
																		<div className="uc_details">
																			<a className="uc_details-icon">
																				<i className="fas fa-gift"></i>							</a>
																			<div className="uc_text">Party Meals by KILO </div>			<a className="uc_btn">Show More</a>		</div>
																	</div>
																</div>
																{/* end Icon Image Content Box */}				</div>
														</div>
													</div>
													<div className="elementor-element elementor-element-70e5389 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="70e5389" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
														<div className="elementor-element elementor-element-545fe24 elementor-widget elementor-widget-ucaddon_icon_image_content_box" data-id="545fe24" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_icon_image_content_box.default">
															<div className="elementor-widget-container">
<div className="uc_icon_image_content_box" id="uc_icon_image_content_box_elementor_545fe24">
																	<div className="uc_content_box_area">



																		<div className="uc_thumb">
																			<Link to="/alppha-foods">
																				<img decoding="async" src="/assets/images/03/ANI03027-scaled.jpg" alt="ANI03027" />
																			</Link>
																		</div>
																		<div className="uc_details">
																			<Link className="uc_details-icon" to="/alppha-foods">
																				<i className="fas fa-gift"></i>							</Link>
																			<div className="uc_text">Alppha Foods </div>			<Link className="uc_btn" to="/alppha-foods">Show More</Link>		</div>
																	</div>
																</div>
																{/* end Icon Image Content Box */}				</div>
														</div>
													</div>
												</div>
												<div className="elementor-element elementor-element-0d3905e e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="0d3905e" data-element_type="container" data-e-type="container">
												</div>
											</div>
										</div>
									</div>



								</div>
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default Brands

